import { KYMW5800Component } from './kymw5800.component';

/**
 * EC企画商品別カテゴリ設定一覧表画面の値を管理するクラス
 *
 * @export KYMW5800Model
 * @class KYMW5800Model
 */
export class KYMW5800Model {

  KYMW5800Component: KYMW5800Component;
  // 画面バインド用変数
  public orderCode: string = <string>'';
  // 部門コード
  public classCode: string = <string>'';
  // カテゴリコード
  public categoryCode: string = <string>'';
  // サイト区分
  public siteDiv: string = <string>'';
  // 媒体
  public mediumType: string = <string>'';
  // ファイル名
  public fileName: string = <string>'';

  public allCoop: boolean = <boolean>true;
  public ibaraki: boolean = <boolean>true;
  public tochigi: boolean = <boolean>true;
  public gunma: boolean = <boolean>true;
  public chiba: boolean = <boolean>true;
  public saitama: boolean = <boolean>true;
  public tokyo: boolean = <boolean>true;
  public nagano: boolean = <boolean>true;
  public niigata: boolean = <boolean>true;

  /**
   * ファイル名を更新する
   *
   * @param {*} serverData ファイル名のサーバ取得データ
   * @memberof KYMW5800Model
   */
  public updateFileName(serverData: any): void {
    this.fileName = serverData.FileName;
  }

}
